import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import Cms from './Cms'

function CMSContainer() {
  const [navParams, setNavParams] = useState({
    navTitle: "CMS",
    navSubTitle: "Welcome to ImagesBazaar Admin Dashboard"
  })

  const handleNavParams = (obj)=>{
    setNavParams({
      ...navParams,
      ...obj
    })
  }
  return (
    <MainLayout navTitle={navParams.navTitle} navSubTitle={navParams.navSubTitle}>
      <Cms handleNavParams={handleNavParams}/>
    </MainLayout>
  )
}

export default CMSContainer